import{useSelector as e}from"react-redux";const o=e;export{o as useAppSelector};
//# sourceMappingURL=hooks.js.map
